module.exports = __webpack_public_path__ + "media/images/gallery/constellations/triangulum/tri_lines-959a44e8fe152d300af8c70655e32f2f.gif";